module.exports = __webpack_public_path__ + "img/feefo-48-en-m.4da54fc.svg";